// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MemberModal_modal-content__1bKsU button{margin-top:2rem}", ""]);
// Exports
exports.locals = {
	"modal-content": "MemberModal_modal-content__1bKsU"
};
module.exports = exports;
